import React from "react";

const FootersLinksList = ({ title = undefined, links }) => {
  return (
    <div className="footer-links-list">
      {title && <div className="footer-links-list__title">{title}</div>}
      <div
        className="footer-links-list__links"
        dangerouslySetInnerHTML={{ __html: links }}
      ></div>
    </div>
  );
};

export default FootersLinksList;
